import type { TCardQuestion, TCardSet, TCoffeeGroup, TCoffeeMatch } from "@/types"
import { api } from "./api"
import type { IAPIParams } from "./types"
import { generateAPIResource, generateSetupActivity } from "./utils"

export const coffeeSetupAPI = generateSetupActivity("/coffee/setup")

// Cards API
export const cardsAPI = {
  ...generateAPIResource<TCardSet>("/cards/sets", {
    create: false,
    update: false,
    remove: false,
  }),
  questions: (setId: string) =>
    api.get<TCardQuestion[]>(`/cards/sets/${setId}/questions`).then((res) => res.data as any[]),
}

export async function fetchAPICoffeeGroups(session_id: string) {
  const { data } = await api.get<TCoffeeGroup[]>(`/coffee/session/${session_id}/groups`)
  return data
}

export async function fetchAPICoffeeMatches(session_id: string, params: IAPIParams = {}) {
  const { data } = await api.get<TCoffeeMatch[]>(`/coffee/session/${session_id}/matches`, {
    params,
  })
  return data
}
